<div *ngIf="selectionService.selectionPermissions.HasDiagnosis" class="mr-20">
    <div class="widget">
        <label>Diagnóstico</label>
        <div class="input-group">
            <div fxFlex.gt-sm="50" id="common-filter-diagnosis-from">
                <mat-form-field class="half-width-form-field">
                  <mat-label>Desde</mat-label>
                    <input matInput [formControl]="filterService.DiagnosisFrom" (keyup)="submitDiagnosis('From')"
                        autocomplete="off">
                </mat-form-field>
            </div>
            <div fxFlex.gt-sm="50" id="common-filter-diagnosis-to">  
                <mat-form-field class="half-width-form-field">
                    <mat-label>Hasta</mat-label>
                    <input matInput [formControl]="filterService.DiagnosisTo" (keyup)="submitDiagnosis('To')"
                        autocomplete="off">
                </mat-form-field>
            </div>
            <div>
                <button class="menu-dropdown menu-btn" mat-button [matMenuTriggerFor]="menu.childMenu"><span
                        class="mat-select-arrow">
                    <mat-icon role="img" class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color" 
                    aria-hidden="true" data-mat-icon-type="font">arrow_drop_down</mat-icon>
                    </span></button>
                <app-diagnosis-menu-item #menu [diagnosisList]="DiagnosisListNested$"
                    (selectDiagnosis)="setSelectedDiagnosis($event)"></app-diagnosis-menu-item>
            </div>
        </div>
    </div>
</div>